export default __webpack_public_path__ + "static/media/whatsapp.5b259539.webp";